<template>
  <div>
    <h4 ref="titleBar" class="reply-list-title top-line">
      全部回复
    </h4>

    <ul v-if="replies.length > 0" class="reply-list">
      <!-- <AdSlot
        :type="'new'"
        :index="0"
        :list-size="replies.length"
        :total="replyCount"
        :load-status="replyLoadStatus"
      /> -->

      <li v-for="reply in replies" :id="`reply_${reply.id}`" :key="reply.id" class="reply-item">
        <template v-if="reply && reply.owner">
          <div class="avatar-profile" @click.stop="directReport(reply)">
            <img class="avatar" :src="reply.owner.avatarUrl" :onerror="onErrorAvatarDefault">
          </div>

          <div class="reply">
            <div class="reply-top-info">
              <UserProfile :item-data="reply" :parent-owner="parentOwner" />

              <PraiseButton
                :comment-id="reply.commentId"
                :reply-id="reply.id"
                :thumbup-count="reply.thumbupCount"
                :is-thumb-up="reply.isThumbUp"
                :reply-content="reply.content"
                :comment-owner="reply.parentReply && reply.parentReply.owner"
                :reply-owner="reply.owner"
              />
            </div>

            <ContentBody
              type="reply"
              :data="reply"
              :comment-owner="parentOwner"
              @click.stop="clickReplyContent(reply)"
            />

            <MenuBar :item-data="reply" />
          </div>
        </template>

        <!-- <AdSlot
          :type="'new'"
          :index="index + 1"
          :list-size="replies.length"
          :total="replyCount"
          :load-status="replyLoadStatus"
        /> -->
      </li>
    </ul>

    <div ref="loadMore" class="load-bar" :style="noContentZoneStyle">
      <div v-if="!isNoContent" class="load-bar-normal">
        <ScrollLoadMore @update:load-more="fetchMoreReplies">
          <div v-if="replyLoadStatus == LoadStatus.LOADING">
            <p class="load-txt load-foot">
              正在加载...
            </p>
          </div>

          <div v-else-if="replyLoadStatus == LoadStatus.LOADCOMPLETED && replies.length">
            <p class="load-txt load-foot">
              无更多内容
            </p>
          </div>

          <div v-else-if="replyLoadStatus == LoadStatus.POOR_NETWORK">
            <p class="load-text">
              网络信号差，请重试
            </p>
          </div>

          <div v-else-if="replyLoadStatus == LoadStatus.NO_CONNECTION">
            <!-- <div class="no-network-connection"></div> -->
            <DynamicGraph :lottie-json="noConnectionLottie" />
            <p class="load-text">
              无网络连接
            </p>
          </div>

          <div v-else-if="replyLoadStatus == LoadStatus.NO_SERVICE">
            <p class="load-text">
              服务器异常，请上划重试
            </p>
          </div>

          <div v-else-if="replyLoadStatus == LoadStatus.DEFAULT">
            <p class="load-txt load-foot">
              正在加载...
            </p>
          </div>
        </ScrollLoadMore>
      </div>

      <div v-else>
        <div
          v-if="
            replyLoadStatus == LoadStatus.LOADERROR
              || replyLoadStatus == LoadStatus.NO_SERVICE
              || replyLoadStatus == LoadStatus.NO_CONNECTION
              || replyLoadStatus == LoadStatus.POOR_NETWORK
          "
          class="load-bar-nothing"
          @click="fetchMoreReplies"
        >
          <div class="load-retry" />
          <p class="load-txt">
            评论加载失败，点击重试
          </p>
        </div>

        <div v-else-if="replyLoadStatus == LoadStatus.LOADING" class="sdk-load-loading load-bar-nothing">
          <div class="load-loading-icon" />
          <p class="load-loading-txt">
            正在加载...
          </p>
        </div>

        <!-- <div
          v-else-if="!replies.length"
          @click.stop="
            onCommentClickThrottle({ owner: parentOwner, commentId }, { directComment: true })
          "
        >
          <NoCommentTip></NoCommentTip>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, toRefs, onMounted, ref, computed } from 'vue';
import { utils, constant } from '@cpc/comment-sdk-common';
import {
  useReplyList,
  useGlobalState,
  useCacheReplyListInject,
} from '@cpc/comment-sdk-core-comment';

import noContent from '../assets/lottie/no-content-light.json?url';
import noContentDark from '../assets/lottie/no-content-dark.json?url';
import loadingError from '../assets/lottie/loading-light.json?url';
import loadingErrorDark from '../assets/lottie/loading-dark.json?url';
import noConnection from '../assets/lottie/no-connection-light.json?url';
import noConnectionDark from '../assets/lottie/no-connection-dark.json?url';
import { useOnCommentClickInject } from '../core/useOnCommentClickProvide/index';
import { commonCommentStat } from '../core/useStat';
import avatarDefault from '../assets/img/avatar_default.png';
import avatarDefaultDark from '../assets/img/avatar_default_dark.png';

// import AdSlot from './AdSlot.vue';
import PraiseButton from './PraiseButton.vue';
import ScrollLoadMore from './ScrollLoadMore.vue';
import ContentBody from './ContentBody.vue';
import MenuBar from './MenuBar.vue';
import UserProfile from './UserProfile.vue';
import DynamicGraph from './DynamicGraph.vue';
import NoCommentTip from './NoCommentTip.vue';

export default defineComponent({
  name: 'CommentSecondDetailReply',

  components: {
    PraiseButton,
    ScrollLoadMore,
    ContentBody,
    MenuBar,
    UserProfile,
    DynamicGraph,
    NoCommentTip,
    // AdSlot,
  },

  props: {
    commentId: {
      type: String,
      required: true,
      default: '',
    },

    replies: {
      type: Array,
      required: true,
      default() {
        return [];
      },
    },

    parentOwner: {
      type: Object,
      required: true,
      default() {
        return {};
      },
    },

    replySize: {
      type: Number,
      required: true,
      default: 0,
    },
  },

  setup(props, { emit }) {
    const { translateTimeStamp } = utils;
    const { userMeta, documentMeta, isNightMode } = toRefs(useGlobalState());
    const { LoadStatus } = constant;

    const { commentId, replies, replySize } = toRefs(props);
    const { fetchMoreReplies, loadStatus: replyLoadStatus, enableUsePreloadList, fetchMoreSubRepliesList } = useReplyList({
      commentId,
      replies,
      replySize,
    });

    const { onCommentClickThrottle } = useOnCommentClickInject();

    const { replyCount } = useCacheReplyListInject();

    onMounted(() => {
      fetchMoreReplies();
      fetchMoreSubRepliesList();
      enableUsePreloadList();
    });

    const titleBar = ref(null);

    const isVideoType = computed(() => {
      return parseInt(String(documentMeta.value.styleType)) === 4;
    });

    const noContentZoneStyle = computed(() => {
      const loadBarHeight
        = window.innerHeight - (titleBar.value?.offsetHeight || 0) - (titleBar.value?.offsetTop || 0);

      return isNoContent.value
        ? {
            // height: Math.max(loadBarHeight, 185) + 'px',
            'display': 'flex',
            'justify-content': 'center',
            'flex-direction': 'column',
          }
        : {};
    });

    const isNoContent = computed(() => {
      return replies.value.length === 0;
    });

    const noContentLottie = computed(() => {
      return isNightMode.value ? noContent : noContent;
    });

    const loadingErrorLottie = computed(() => {
      return isNightMode.value ? loadingErrorDark : loadingError;
    });

    const noConnectionLottie = computed(() => {
      return isNightMode.value ? noConnectionDark : noConnection;
    });

    const onErrorAvatarDefault = (event) => {
      event.target.src = isNightMode.value ? avatarDefaultDark : avatarDefault;
    };

    const uid = userMeta.value.uid;
    const directReport = (reply) => {
      commonCommentStat(20084690, {
        userId: reply.owner.id,
      });

      if (uid === reply.owner.id) {
        return;
      }

      onCommentClickThrottle(reply, {
        directReport: true,
      });
    };

    const clickReplyContent = (reply) => {
      commonCommentStat(20084687);

      onCommentClickThrottle(reply, {
        directComment: true,
      });
    };

    return {
      translateTimeStamp,
      LoadStatus,
      replyLoadStatus,

      fetchMoreReplies,
      onCommentClickThrottle,

      noContentLottie,
      loadingErrorLottie,
      noConnectionLottie,

      isNoContent,
      noContentZoneStyle,
      isVideoType,
      titleBar,
      onErrorAvatarDefault,
      directReport,
      clickReplyContent,
      replyCount,
    };
  },
});
</script>

<style lang="scss" scoped>
@import '../assets/css/common.scss';
@import '../assets/css/loading.scss';
@import '../assets/css/load-bar.scss';
@import '../assets/css/styling-mixin.scss';

.reply-list-title {
  position: relative;
  font-family: ColorFont-Regular, 'OPlusSans 3.0';
  font-size: 48px;
  font-weight: 500;
  line-height: 120px;
  padding-top: 24px;
  @include os-browser-styling('', '', false, false, true, true) {
    color: rgba($color: #fff, $alpha: 0.9);
  }
}

.reply-list {
  margin: 0;
  border: 0;
  padding: 0 0 45px 0;
  list-style: none;

  .reply-item {
    display: flex;
    // margin-top: 48px;
    padding: 30px 48px;
    color: #000;

    &:first-child {
      margin-top: 0;
    }
  }
}

.avatar-profile {
  flex-shrink: 0;
  width: 96px;
  height: 96px;
  border-radius: 54px;
  position: relative;
  &:active {
    transform: scale(0.8);
    transition: all 0.3s ease;
  }

  @include setRounded1pxBorder(rgba(0, 0, 0, 0.1), before, 54px);

  .avatar {
    width: 96px;
    height: 96px;
    border-radius: 54px;
    margin-top: 0;
    vertical-align: top;
  }
}

.reply {
  margin-left: 30px;
  flex: 1;
  font-size: 36px;
  font-family: ColorFont-Regular, 'OPlusSans 3.0';
  min-width: 0; // fix flex & ellipsis

  .reply-top-info {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
}

.load-bar {
  .load-bar-nothing {
    @include os-browser-styling(13, 'not-video') {
      margin-top: 66px;
    }
  }
}

html[data-theme='dark'] {
  .no-network-connection {
    background: url('../assets/img/no-network-connection_dark.png') center center / contain
      no-repeat;
  }
}
</style>
